import { ImgHTMLAttributes } from 'react';
import { DEFAULT_PROFILE_IMAGE, DEFAULT_PROFILE_IMAGES } from 'constants.js.erb';
import Image from 'components/Image';

interface ProfileImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  genderSport?: string;
}

export default function ProfileImage({ src, genderSport, ...props }: ProfileImageProps) {
  const defaultSrc = genderSport ? DEFAULT_PROFILE_IMAGES[genderSport] || DEFAULT_PROFILE_IMAGE : DEFAULT_PROFILE_IMAGE;

  return (
    <Image src={src || defaultSrc} onError={src ? ({ target }) => ((target as HTMLImageElement).src = defaultSrc) : undefined} {...props} />
  );
}
